import { ApiPatchOperation } from '@domain/schemas/api-patch-operation';
import type { TeamStatus } from '@features/user-teams';
import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import type { CreateTeamResponse, UpdateTeamResponse } from '@responses/teams';
import axios from 'axios';

export const createTeam = async (name: string): Promise<CreateTeamResponse> => {
  const networkPayload = await getRequestAuthPayload({ method: 'post', url: '/teams', data: { name } });
  const { data } = await axios<CreateTeamResponse>(networkPayload);
  return data;
};

export const renameTeam = async ({ id, name }: { id: number; name: string }): Promise<UpdateTeamResponse> => {
  const networkPayload = await getRequestAuthPayload({ method: 'patch', url: `/teams/${id}`, data: { name } });
  const { data } = await axios<UpdateTeamResponse>(networkPayload);
  return data;
};

export const setTeamStatus = async ({
  id,
  status,
}: {
  id: number;
  status: TeamStatus;
}): Promise<UpdateTeamResponse> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'patch',
    url: `/teams/${id}`,
    data: { status, operation: ApiPatchOperation.TeamStatusUpdate },
  });
  const { data } = await axios<UpdateTeamResponse>(networkPayload);
  return data;
};
